module.exports = __webpack_public_path__ + "img/Hookworm.e4675513.png";